import Swiper, { Navigation } from "swiper";

export default class ProperiesSlider {
    constructor() {
        this.slider = '.js-properties-slider';
        
        this.init();
    }

    init() {

        const swiper = new Swiper(this.slider, {
            modules: [Navigation],
            loop: false,
            spaceBetween: 8,
            slidesPerView: 1.15,
            allowTouchMove: true,
            threshold: 20,
            navigation: {
                nextEl: ".js-properties-slider-next",
                prevEl: ".js-properties-slider-prev",
            },
            breakpoints: {
                1024: {
                    slidesPerView: 3,
                }
            }
        });

    }
}

new ProperiesSlider;